export default __webpack_public_path__ + "fbaa3502d07a299731a77c6aab97f91c.gif";